/*
TODO: Handle routing with React router or similar to be able to go back in browser history
TODO: Make sure to focus on the close button to be avble to tab trough the content
*/

import React, { useEffect, forwardRef, useRef } from "react";
import Styled, { css } from "styled-components/macro";
import Button from "../Button";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
// import { createPrettyURI } from 'components';

const Styles = Styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  inset: 0px;
  background-color: ${(props) =>
    props.isOpen ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)"};
  z-index: 10;
  pointer-events: ${(props) => (props.isOpen ? "all" : "none")};
  transition: background-color var(--t-slow) var(--e-out);

  .sidebar__frame {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    inset: 0px;
    height: 100%;
    padding: var(--s-tiny) var(--s-small) 0 var(--s-small);
    background-color: ${(props) => `var(${props.color})`};
    color: ${(props) => `var(${props.color}--text)`};
    box-shadow: var(--s-6dp);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: auto;
    -webkit-overflow-scrolling: touch;

    transform: translate3d(100%,0,0);
    @media (min-width: 800px) {
      opacity: 0;
      transform: translate3d(30%,0,0);
    }
    @media (prefers-reduced-motion: reduce) {
      opacity: 0;
      transform: translate3d(0%,0,0);
    }

    transition: transform var(--t-base) var(--e-in), opacity var(--t-base) var(--e-in);

    ${(props) =>
      props.isOpen &&
      css`
        transform: translate3d(0, 0, 0);
        transition: transform var(--t-slow) var(--e-out),
          opacity var(--t-slow) var(--e-out);
        @media (min-width: 800px), (prefers-reduced-motion: reduce) {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      `}
  }


  .sidebar__button {
    color: inherit;
  }
  /* .sidebar__button.button-icon {
    position: absolute;
    margin: 0;
    top: var(--s-small);
    right: var(--s-small);
  } */
  .sidebar__content {
    flex: 1;
    /* height: 50vh; */
    /* height: auto; */
    /* height: calc(100vh - ); */
    position: relative;
    padding-bottom: var(--s-medium);
    p {
      hyphens: auto;
    }
  }
`;

const Sidebar = forwardRef((props, ref) => {
  // const closeButton = useRef(null);
  const sidebarContent = useRef(null);

  // const handleFocus = (isOpen) => {
  //   if (!ref) return;
  //   if (isOpen) ref.current.focus();
  //   console.log('ref', ref);
  // }

  // componentDidMount
  useEffect(() => {
    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  useEffect(() => {
    console.log(document.body);
    if (props.open) {
      disableBodyScroll(sidebarContent.current);
      // window.history.pushState('#open', null, '#open');
    } else {
      enableBodyScroll(sidebarContent.current);
    }
  }, [props.open]);

  return (
    <Styles
      className="sidebar__frame"
      isOpen={props.open}
      aria-hidden={!props.open}
      id={"sidebar" + props.id}
      color={props.color}
    >
      <div className="sidebar__frame" ref={sidebarContent}>
        <Button
          ref={ref}
          onlyIcon
          type="button"
          aria-controls={"sidebar" + props.id}
          aria-expanded={props.open}
          className="sidebar__button sidebarCloseButton"
          onClick={props.toggleOpen}
          small
          {...props.buttonProps}
        >
          {props.closeIcon}
        </Button>
        <div className="sidebar__content">{props.children}</div>
      </div>
    </Styles>
  );
});

Sidebar.defaultProps = {
  open: false,
  id: "_",
  toggleOpen: () => {
    console.error("Sidebar needs a function prop named toggleOpen");
  },
  closeIcon: "x",
  children: undefined,
  color: "--c-white",
};

export default Sidebar;
